import { Flex, Grid } from '@backstage/ui';
import { EntityHasApisCard } from '@backstage/plugin-api-docs';
import {
  EntityAboutCard,
  EntityHasComponentsCard,
  EntityHasResourcesCard,
  EntityLayout,
  EntityLinksCard,
} from '@backstage/plugin-catalog';
import { Direction, EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import {
  RELATION_API_CONSUMED_BY,
  RELATION_API_PROVIDED_BY,
  RELATION_CONSUMES_API,
  RELATION_DEPENDENCY_OF,
  RELATION_DEPENDS_ON,
  RELATION_HAS_PART,
  RELATION_PART_OF,
  RELATION_PROVIDES_API,
} from '@backstage/catalog-model';

import { RadixCard } from '@internal/backstage-plugin-radix';
import { AzureCard } from '@internal/backstage-plugin-azure';
import { EntityMarkdownCard } from '../EntityMarkdown/EntityMarkdownCard';
import { EntityWarningContent } from './EntityWarningContent';

export const SystemEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Flex direction="column" gap="6">
        <EntityWarningContent />
        <Grid.Root columns={{ initial: '1', md: '2' }} gap="6">
          <Grid.Item>
            <Flex direction="column" gap="6">
              <EntityAboutCard />
              <RadixCard />
              <AzureCard />
            </Flex>
          </Grid.Item>
          <Grid.Item>
            <Flex direction="column" gap="6">
              <EntityCatalogGraphCard height={400} />
              <EntityLinksCard />
            </Flex>
          </Grid.Item>
        </Grid.Root>
        <EntityMarkdownCard />
      </Flex>
    </EntityLayout.Route>
    <EntityLayout.Route path="/architecture" title="Architecture">
      <Flex direction="column" gap="6">
        <EntityHasComponentsCard />
        <EntityHasApisCard />
        <EntityHasResourcesCard />
      </Flex>
    </EntityLayout.Route>
    <EntityLayout.Route path="/diagram" title="Diagram">
      <EntityCatalogGraphCard
        direction={Direction.TOP_BOTTOM}
        title="System Diagram"
        height={700}
        relations={[
          RELATION_PART_OF,
          RELATION_HAS_PART,
          RELATION_API_CONSUMED_BY,
          RELATION_API_PROVIDED_BY,
          RELATION_CONSUMES_API,
          RELATION_PROVIDES_API,
          RELATION_DEPENDENCY_OF,
          RELATION_DEPENDS_ON,
        ]}
        unidirectional={false}
      />
    </EntityLayout.Route>
  </EntityLayout>
);
